import { Lead, LeadApiResponse, PersonalLead } from 'models/Lead';

export const isLeadPersonal = (
  lead: Lead | PersonalLead | LeadApiResponse,
): lead is PersonalLead => {
  return (lead as PersonalLead)?.personalCampaignId !== undefined;
};

export const convertLeadApiResponseToLead = (
  apiResponse: LeadApiResponse,
): Lead | PersonalLead => {
  if (isLeadPersonal(apiResponse)) return apiResponse;
  const { lead, ...rest } = apiResponse;

  return {
    ...rest,
    contact: lead
      ? {
          ...lead,
          firstOutreach: lead.first_outreach,
          firstSubject: lead.first_subject,
          firstName: lead.first_name,
          lastName: lead.last_name,
        }
      : undefined,
  };
};

export const replaceTemplatePlaceholders = (
  template: string,
  values: Record<string, string>,
): string => {
  return template?.replace(/{{(.*?)}}/g, (_, key) => {
    const trimmedKey = key.trim();
    return values[trimmedKey] ?? `{{${trimmedKey}}}`; // If not found, keep placeholder
  });
};
